export default __webpack_public_path__ + "static/media/verticalBanner.d483f83d.png";